module.exports = __webpack_public_path__ + "static/Construction-Photo2-078660f757fb0891f2cfc4fcc500031c.png";